export default {
  campusList: state => state.campuses,
  rentAreas: state => state.rentcarAreas,
  rentAreaPointers: state => areaId =>
    state.rentcarAreas.filter(rentItem => rentItem.AreaID == areaId)
};
